export default __webpack_public_path__ + "static/ui-personal-data-1f6fbfc94fc243a05e26acfefada5cd8.png";